import { RESET_OPEN_DEAL_STATE } from '../actionTypes/openDealActionTypes';
import { NAVIGATE_TO_DASHBOARD } from '../actionTypes/roleAssumptionActionTypes';

export const navigateToDashboard = () => ({
    type: NAVIGATE_TO_DASHBOARD
});

export const resetOpenDeal = () => ({
    type: RESET_OPEN_DEAL_STATE
});
